import {useEffect, useRef, useState} from 'react';
import {Button} from '../atoms/Button';
import {Typography} from '../atoms/Typography';
import {useBrowserWidth} from '../hooks/useBrowserWidth';
import {DiamondIcon} from '../svg/DiamondIcon';

export const TemplateTypeIndicator = (props) => {
  const {isPrem = false, isGc = false, onClick, dataQaValue} = props;

  const type = () => {
    if (isGc) return 'Premium Greeting Card';
    return isPrem ? 'Premium Invitation' : 'Free Invitation';
  };

  const classModifier = () => {
    if (isGc) return '--gc';
    return isPrem ? '--premium' : '';
  };

  const browserWidth = useBrowserWidth();
  const rolloverRef = useRef(null);
  const [typeIndicatorHeight, setTypeIndicatorHeight] = useState();

  // biome-ignore lint/correctness/useExhaustiveDependencies: trigger when browser width changes
  useEffect(() => {
    const indicator = document.querySelector('#template-type-indicator-first');
    if (!indicator) return;
    setTypeIndicatorHeight(`${indicator.clientHeight}px`);
  }, [browserWidth]);

  return !onClick || isGc || !isPrem ? (
    <div className={`template-indicator${classModifier()} template-indicator--static`}>
      {isPrem && <DiamondIcon className="template-indicator-icon" />}
      <Typography variant="paragraph3" className="mobile-paragraph3">
        {type()}
      </Typography>
    </div>
  ) : (
    <Button
      className="template-indicator--button"
      data-qa-id="premium-invitation-indicator"
      data-qa-value={dataQaValue}
      variant="transparent"
      onClick={onClick}
    >
      <DiamondIcon className="template-indicator-icon" />
      <div
        className="template-indicator__with-rollover"
        ref={rolloverRef}
        style={{height: typeIndicatorHeight}}
      >
        <Typography
          className={`template-indicator${classModifier()}`}
          id="template-type-indicator-first"
          variant="paragraph3"
        >
          {type()}
        </Typography>
      </div>
    </Button>
  );
};
